import APIServiceLookUp from './serviceAPI';
import { API_URL } from './models/AppConstent';

export default class ServiceGallery {
    lookupService = new APIServiceLookUp();

    async getAllGallery(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}gallery/getAllGallery`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async setGallery(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}gallery/setGallery`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async updateGallery(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}gallery/updateGallery`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async delGallery(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}gallery/delGallery`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }
}